/* eslint-disable
    consistent-return,
    default-case,
    global-require,
    new-cap,
    react/prefer-stateless-function
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import PropTypes from 'prop-types';
import _ from 'underscore';

import React from 'react';
import ReactDOM from 'react-dom';
import asm from 'assembly/Asm';
import {assertAndContinue} from 'Asserts';
import * as AssemblyPrimers from 'assembly/AssemblyPrimers';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import * as clipboard from 'util/Clipboard';
import * as colors from 'lib/Colors';
import Enzymes from 'molbio/enzymes/backbone/Enzymes';
import {
  PRIMERS_COPIED_MSG,
  downloadOligos,
  formatOligos,
  getOligoFilename,
} from 'molbio/oligos/ExportOligoUtil';
import {ASSEMBLY_TYPE} from 'constants/AssemblyConstants';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import notifications from 'notifications';
import PrimerAssemblyMismatchRowTemplate from 'assembly/PrimerAssemblyMismatchRowTemplate';
import PrimerAssemblyRowTemplate from 'assembly/PrimerAssemblyRowTemplate';
import PrimerAssemblyTabOptionsTemplate from 'assembly/PrimerAssemblyTabOptionsTemplate';
import PrimerAssemblyTabTemplate from 'assembly/PrimerAssemblyTabTemplate';
import PrintableSummaryTemplate from 'assembly/PrintableSummaryTemplate';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import * as logging from 'util/Logging';
import * as sequtil from 'molbio/SeqUtil';
import {debounce} from 'ts-debounce';
import runModal from 'ui-library/runModal';
import AssemblyTabSettingsModal from 'assembly/tabs/AssemblyTabSettingsModal';

const COMMON_ENZYMES = Enzymes.getCommonEnzymes();

class OptionsView extends Backbone.View {
  static initClass() {
    this.prototype.template = PrimerAssemblyTabOptionsTemplate;
    this.prototype.className = 'navbar';

    this.prototype.events = {
      'click .js-print': 'print',
      'click .js-save': 'save',
      'click .js-clone-into-wizard': 'cloneIntoWizard',
      'click .js-primer-tab-settings': function () {
        runModal(AssemblyTabSettingsModal, {});
      },
    };
  }

  initialize() {
    this.listenTo(
      this.model.get('sequence'),
      'change:writable change:permissions change:currentVersion',
      this.renderFinalize
    );
    this.listenTo(this.model.get('sequence')._sequence(), 'change:finalized', this.renderFinalize);
    this.listenTo(this.model.get('rows'), 'reset', function () {
      this.renderCopyButton();
      this.renderExportButton();
    });
    this.listenTo(this.model, 'print', this.print);
  }

  remove() {
    super.remove();
    if (this.selectorView != null) {
      this.selectorView.remove();
    }
    if (this.clipboard != null) {
      clipboard.unglue(this.clipboard);
    }
  }

  print() {
    LoadingScreen.show();
    const sequence = this.model.get('sequence')._sequence();
    const showSummary = () => {
      this.model.set({showPrintableSummary: true});
      const headHTML = $('html').find('head').html();
      const tabHTML = this.$el.closest('.buffer-container').find('.buffer-content').html();
      const printWindow = window.open();
      if (printWindow == null) {
        // This block should never be reached, but we deal with it instead of erroring in case
        // browsers introduce some weird behavior.
        logging.warn('Assembly tab blocked');
        notifications.warn('Please disable popup blockers and try again in a few seconds.');
        this.model.set({showPrintableSummary: false});
        LoadingScreen.hide();
        return;
      }
      printWindow.document.open();
      printWindow.document.write(PrintableSummaryTemplate({head: headHTML, tab: tabHTML}));
      printWindow.document.close();
      printWindow.focus();
      this.model.set({showPrintableSummary: false});
      LoadingScreen.hide();
    };
    if (sequence.get('hasSnapshot')) {
      showSummary();
    } else {
      // This call must be synchronous because the browser pops blockups that are generated from
      // events not triggered directly by the user. Chaining these synchronous calls appears to
      // involve the popup blocker as well, as does deferring anything.
      $.ajax({
        url: `/1/api/sequences/${sequence.id}`,
        async: false,
        dataType: 'json',
        success(res) {
          if (res.hasSnapshot) {
            sequence.set({snapshot_url: res.snapshot_url, hasSnapshot: true});
            showSummary();
          } else {
            notifications.warn('Sequence preview is not available yet. Please try again in a few seconds.');
            LoadingScreen.hide();
          }
        },
      });
    }
  }

  save() {
    this.$('.js-save').addClass('disabled');
    const params = {};
    if (this.model.get('sequence').assemblyType() === ASSEMBLY_TYPE.GOLDEN_GATE) {
      params.fragmentResultStickyEnds = {};
      this.model
        .get('sequence')
        .fragmentResults()
        .each((fragmentResult) => {
          params.fragmentResultStickyEnds[fragmentResult.id] = {};
        });
      const stickyEndRanges = asm.goldenGate.stickyEndRanges(this.model.get('sequence')._sequence());
      for (const {start, end, upstreamFragment, downstreamFragment} of Array.from(stickyEndRanges)) {
        const stickyEnd = this.model.get('sequence').residueSlice(start, end);
        params.fragmentResultStickyEnds[upstreamFragment.id].end = stickyEnd;
        params.fragmentResultStickyEnds[downstreamFragment.id].start = stickyEnd;
      }
    }
    this.model
      .get('sequence')
      .finalize(params)
      .always(() => this.$('.js-save').removeClass('disabled'))
      .fail(notifications.notifyError);
  }

  renderFinalize() {
    const hideFinalize =
      this.model.get('sequence')._sequence().finalized() || !this.model.get('sequence').allowFeatureEdits();
    this.$('.js-finalize-group').toggleClass('hidden', hideFinalize);
  }

  cloneIntoWizard() {
    const {assemblies} = require('assembly/AssemblyModels');
    LoadingScreen.show();
    const toClone = this.model.get('sequence')._sequence().assembly();
    toClone
      .clone()
      .done((assembly) => {
        assemblies.add(assembly);
        if (toClone.allFragments().length !== assembly.allFragments().length) {
          notifications.warn(
            `Some sequences that were originally used in this assembly have been shortened \
or deleted. You will need to re-set those fragments.`,
            {duration: 10}
          );
        }
      })
      .fail(notifications.notifyError)
      .always(() => {
        LoadingScreen.hide();
      });
  }

  canExportPrimers() {
    return window.user != null;
  } // must be logged in

  primersToExport() {
    return this.model.get('rows').map((row) => {
      const primer = this.model.primers.get(row.id);
      return {name: primer.name(), nucleotideType: primer.nucleotideType(), bases: primer.bases()};
    });
  }

  renderCopyButton() {
    const $btn = this.$('.js-copy-primers');
    if (!this.canExportPrimers()) {
      $btn.addClass('hidden');
      return;
    }
    $btn.removeClass('hidden');
    const primersToExport = this.primersToExport();
    $btn.toggleClass('disabled', primersToExport.length === 0);
    if (this.clipboard != null) {
      clipboard.unglue(this.clipboard);
    }
    const primerData = formatOligos(primersToExport, 'tsv');
    this.clipboard = clipboard.glue($btn[0], {
      dataTransform() {
        return primerData;
      },
      notifyCopied() {
        return notifications.success(PRIMERS_COPIED_MSG, {
          duration: 30,
          id: 'tsv-primer-copied',
        });
      },
    });
  }

  renderExportButton() {
    const $btn = this.$('.js-export-group .button');
    if (!this.canExportPrimers()) {
      $btn.addClass('hidden');
      return;
    }
    $btn.removeClass('hidden');
    const primersToExport = this.primersToExport();
    const disabled = primersToExport.length === 0;
    $btn.toggleClass('is-disabled', disabled);
    if (primersToExport.length >= 1) {
      $btn.click(() => {
        if (disabled) {
          return;
        }
        downloadOligos({
          oligos: primersToExport,
          filename: getOligoFilename(this.model.get('sequence').name()),
        });
      });
    }
  }

  render() {
    this.$('.js-print').tooltip('destroy');
    this.$el.html(this.template());
    this.$('.js-print').tooltip({title: 'Printable Summary', placement: 'bottom', container: 'body'});
    this.$('.js-clone-into-wizard').tooltip({
      placement: 'bottom',
      title: 'Open a copy of this assembly in the assembly wizard',
      container: 'body',
      trigger: 'hover',
    });
    this.$('.js-save').tooltip({
      placement: 'bottom',
      title: `\
Finalize the assembly to enable creating alignments and editing anywhere in the sequence\
`,
      trigger: 'hover',
      container: 'body',
    });
    this.renderExportButton();
    this.renderFinalize();
    this.renderCopyButton();
    return this;
  }
}
OptionsView.initClass();

class PrimerRow extends Backbone.View {
  static initClass() {
    this.prototype.template = PrimerAssemblyRowTemplate;
    this.prototype.tagName = 'tr';

    this.prototype.events = {
      'click .js-primer': 'openPrimer',
      'click .js-pair': 'openPair',
      'click .js-misprime a': 'openMisprime',
      'click .js-monomer a': 'openMonomer',
    };
  }

  initialize({tabModel, showBinding, showHomology}) {
    this.tabModel = tabModel;
    this.showBinding = showBinding;
    this.showHomology = showHomology;
    this.listenTo(this.model, 'change', debounce(this.render, 100));
    this.sequence = this.model.get('sequence');
  }

  getPrimer() {
    return this.sequence.sequencePrimers().get(this.model.id);
  }

  openPrimer(e) {
    const primer = this.getPrimer();
    primer.dblClick(this.sequence, e.shiftKey);
  }

  openPair() {
    return this.sequence.selectPrimerPair(this.model.get('pairId'));
  }

  openMisprime() {
    return this.model.get('misprimeHandler')();
  }

  openMonomer() {
    return this.model.get('dgHandler')();
  }

  render() {
    const primer = this.getPrimer().get('_primer');
    // eslint-disable-next-line no-restricted-syntax
    const info = _.extend(this.model.toJSON(), {
      primerBases: AssemblyPrimers.basesHTML(this.sequence._sequence(), primer, {isAssemblyPrimer: true}),
      fragmentResultColor: this.tabModel.lighten(this.model.get('fragmentResultColor')),
      finalized: this.sequence.finalized(),
      showBinding: this.showBinding,
      showHomology: this.showHomology,
      showPrintableSummary: this.tabModel.showPrintableSummary(),
    });
    this.$el.html(this.template(info));
    return this;
  }
}
PrimerRow.initClass();

class MismatchRow extends Backbone.View {
  static initClass() {
    this.prototype.template = PrimerAssemblyMismatchRowTemplate;
    this.prototype.tagName = 'tr';

    this.prototype.events = {
      'click .js-fragment-sequence': 'openFragmentSequence',
      click() {
        return this.model.click(this.tabModel.get('sequence'));
      },
    };
  }

  initialize(options) {
    this.tabModel = options.tabModel;
    this.listenTo(this.model, 'change:selected', function (model, value) {
      return this.$el.toggleClass('active', value);
    });
    this.listenTo(this.tabModel.get('sequence')._sequence(), 'change:startIndex', () => {
      assertAndContinue(false, 'Start index changed while mismatch row rendered');
    });
  }

  openFragmentSequence() {
    return this.tabModel.openFragmentSequence(this.model);
  }

  render() {
    // eslint-disable-next-line no-restricted-syntax
    const info = _.extend(this.model.toJSON(), {
      fragmentResultColor: this.tabModel.lighten(this.model.get('fragmentResultColor')),
      pos: sequtil.modelToDisplay(this.model.get('pos'), this.tabModel.get('sequence').startIndex()),
      showPrintableSummary: this.tabModel.showPrintableSummary(),
    });
    this.$el.html(this.template(info));
    return this;
  }
}
MismatchRow.initClass();

class AssemblyPreview extends React.Component {
  static propTypes = {
    fragmentSequenceNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    snapshotURL: PropTypes.string.isRequired,
  };

  render() {
    return (
      <fieldset>
        <legend>Assembly Preview</legend>
        <Row>
          <Col xs={8}>
            <img src={this.props.snapshotURL} />
          </Col>
          <Col xs={4}>
            <table className="table table-condensed table-hover">
              <thead>
                <tr>
                  <th>Parent Sequence</th>
                </tr>
                <tbody>
                  {Array.from(this.props.fragmentSequenceNames).map((name, i) => (
                    <tr key={i}>
                      <td
                        className="printable-color"
                        style={{borderLeftColor: colors.shuffledPastelColors[i]}}
                      >
                        {name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </thead>
            </table>
          </Col>
        </Row>
      </fieldset>
    );
  }
}

class DesignParameters extends React.Component {
  static propTypes = {
    assemblyType: PropTypes.string.isRequired,
    parameters: PropTypes.object.isRequired,
  };

  renderParameter = (key, value) => {
    switch (key) {
      case 'tmAnneal':
      case 'bindingRegionMinTM':
        return [
          <span>
            Min T<sub>m</sub>
            {" for primer's binding bases"}
          </span>,
          `${value} \u00B0C`,
        ];
      case 'tmWhole':
        return [
          <span>
            Min T<sub>m</sub>
            {' for whole primer'}
          </span>,
          `${value} \u00B0C`,
        ];
      case 'tmDiff':
      case 'primerPairMaxTMDiff':
        return [
          <span>
            Max T<sub>m</sub>
            {' diff for primer pairs'}
          </span>,
          `${value} \u00B0C`,
        ];
      case 'minOverlap':
        return ['Min length of homology/binding regions', value];
      case 'maxOverlap':
        return ['Max length of homology/binding regions', value];
      case 'preRecognitionSiteLength':
        return ['Pre-recognition site length', value];
      case 'preRecognitionSiteBases':
        return ['Pre-recognition site bases', value || '(random)'];
      case 'bindingRegionMinLength':
        return ['Min length for binding region', value];
      case 'enzymeID':
        return ['Type IIS Enzyme', COMMON_ENZYMES.get(value).name()];
      default:
        throw new Error(`Unexpected parameter key: ${key}`);
    }
  };

  render() {
    const orderedKeys = (() => {
      switch (this.props.assemblyType) {
        case ASSEMBLY_TYPE.GIBSON:
          return ['tmAnneal', 'tmWhole', 'tmDiff', 'minOverlap', 'maxOverlap'];
        case ASSEMBLY_TYPE.GOLDEN_GATE:
          return [
            'preRecognitionSiteLength',
            'preRecognitionSiteBases',
            'bindingRegionMinTM',
            'bindingRegionMinLength',
            'primerPairMaxTMDiff',
            'enzymeID',
          ];
      }
    })();
    return (
      <fieldset>
        <legend>Design Parameters</legend>
        <table className="table table-condensed table-hover">
          <thead>
            <tr>
              <th>Parameter</th>
              <th>Value</th>
            </tr>
            <tbody>
              {(() => {
                const result = [];
                for (const key of Array.from(orderedKeys)) {
                  const [renderedKey, renderedValue] = Array.from(
                    this.renderParameter(key, this.props.parameters[key])
                  );
                  result.push(
                    <tr key={key}>
                      <td>{renderedKey}</td>
                      <td>{renderedValue}</td>
                    </tr>
                  );
                }
                return result;
              })()}
            </tbody>
          </thead>
        </table>
      </fieldset>
    );
  }
}

class TabView extends Backbone.View {
  static initClass() {
    this.prototype.template = PrimerAssemblyTabTemplate;
    this.prototype.className = 'primer-assembly-tab-results buffer-tab';

    this.prototype.showBinding = true;

    this.prototype.showHomology = true;
  }

  initialize() {
    this.sequence = this.model.get('sequence');
    this.listenTo(this.sequence._sequence(), 'change:finalized', this.render);
    this.listenTo(this.model.get('rows'), 'reset', this.render);
    this.listenTo(this.model, 'change:showPrintableSummary', this.render);
    this.listenTo(this.sequence.primerAssemblyMismatches(), 'reset', this._renderMismatchRows);
    this.primerRows = [];
    this.mismatchRows = [];
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.$('.design-parameters-mount')[0]);
    this._removeMismatchRows();
    this._removePrimerRows();
    return super.remove();
  }

  _removePrimerRows() {
    for (const row of Array.from(this.primerRows)) {
      row.remove();
    }
  }
  _renderPrimerRows() {
    this._removePrimerRows();
    this.primerRows = this.model.get('rows').map((rowModel) => {
      const row = new PrimerRow({
        model: rowModel,
        tabModel: this.model,
        showBinding: this.showBinding,
        showHomology: this.showHomology,
      });
      this.$('.primer-assembly-primers tbody').append(row.render().el);
      return row;
    });
  }

  _removeMismatchRows() {
    for (const row of Array.from(this.mismatchRows)) {
      row.remove();
    }
  }
  _renderMismatchRows() {
    this._removeMismatchRows();
    this.mismatchRows = this.sequence.primerAssemblyMismatches().map((mismatch) => {
      const row = new MismatchRow({model: mismatch, tabModel: this.model});
      this.$('.js-mismatches-area tbody').append(row.render().el);
      return row;
    });
    this.$('.js-mismatches-area p').toggleClass('hidden', this.mismatchRows.length !== 0);
  }

  render() {
    this.$el.html(
      this.template({
        finalized: this.sequence.finalized(),
        showBinding: this.showBinding,
        showHomology: this.showHomology,
        isGoldenGate: this.sequence.assemblyType() === ASSEMBLY_TYPE.GOLDEN_GATE,
        showPrintableSummary: this.model.showPrintableSummary(),
      })
    );
    this._renderPrimerRows();
    if (!this.sequence.finalized()) {
      this._renderMismatchRows();
    }
    this.$('.js-mismatches-area').toggleClass('hidden', this.sequence.finalized());

    if (this.model.showPrintableSummary()) {
      renderToDOM(
        <AssemblyPreview
          fragmentSequenceNames={this.sequence
            .fragmentResults()
            .map((fragmentResult) => __guard__(fragmentResult.parent(), (x) => x.name))}
          snapshotURL={this.sequence._sequence().get('snapshot_url')}
        />,
        this.$('.assembly-preview-mount')[0]
      );
    } else {
      ReactDOM.unmountComponentAtNode(this.$('.assembly-preview-mount')[0]);
    }

    renderToDOM(
      <DesignParameters
        assemblyType={this.sequence.assemblyType()}
        parameters={this.sequence._sequence().assembly().parameters()}
      />,
      this.$('.design-parameters-mount')[0]
    );

    return this;
  }
}
TabView.initClass();

export {TabView, OptionsView};

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
